import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {black, white} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  header: {
    marginBottom: indent / 4,
  },
  timestampContainer: {
    marginBottom: indent * 1.5,
  },
  headerText: {
    color: black,
  },
  content: {
    backgroundColor: white,
  },
  loadingIndicator: {
    marginVertical: 200,
  },
  summaryCardsContainerWeb: {
    marginBottom: 0,
  },
  summaryCardsRow: {
    flexDirection: 'row',
    flexWrap: 'nowrap',
    alignItems: 'stretch',
  },
  summaryCardWeb: {
    marginRight: 0,
  },
  webSectionSpacing: {
    marginBottom: 0,
  },
});
